import { Ga4PricedItem, getGa4Items, gtmSendEvent } from "@wojo/analytics";
import { useEffect } from "react";
import { useTripBuilder } from "./TripBuilderContext";
import {
    TripBuilderDraftQuoteFragment,
    TripComponentType,
} from "../../../../generated/graphql";
import Cookies from "js-cookie";
import currency from "currency.js";
import { getCurrency } from "../../../../hooks";

export const useDraftQuoteAnalytics = (
    draftQuote: TripBuilderDraftQuoteFragment | null,
) => {
    const { departure } = useTripBuilder();
    const { price } = getCurrency();
    const customPromo = Cookies.get("promo");

    useEffect(() => {
        if (draftQuote?.order.__typename !== "Quote") {
            return;
        }
        const isCustomPromoAlreadyApplied = draftQuote.order.trips.some(
            (trip) =>
                trip.openPromoLineItems.some(
                    (promo) => promo.promoCode === customPromo,
                ),
        );
        const { currencyCode, businessCode, gcDepartureId, grandTotal } =
            draftQuote.order;
        const departurePrice = price(departure?.price.value ?? []).value;
        const commonProps = {
            item_brand: businessCode,
            item_category3: gcDepartureId ? "Groups" : "Indies",
            tourCode: departure?.tourCode || "",
        };
        const items = draftQuote.order.trips.reduce((acc, trip) => {
            const totalDiscount = trip.openPromoLineItems
                .filter((promo) => promo.targetType === TripComponentType.Tour)
                .reduce((acc, promo) => acc.add(promo.price.value), currency(0))
                .multiply(-1).value;

            acc.push({
                item_id: departure?._id || "",
                item_name: departure?.tourContent?.name || "",
                discount: totalDiscount,
                item_variant: "Departure",
                price: currency(departurePrice).subtract(totalDiscount).value,
                quantity: 1,
                activityLevel:
                    departure?.tourContent?.tour?.activityLevelContent?.name ||
                    "",
                classLevel:
                    departure?.tourContent?.tour?.classLevelContent?.name || "",
                onSale: totalDiscount > 0,
                groupTrip: !!gcDepartureId,
                hasExtension: !!departure?.activeExtension,
                prodStatus: departure?.status,
                promoCodeApplied: isCustomPromoAlreadyApplied
                    ? customPromo
                    : "",
            });

            return acc;
        }, new Array<Ga4PricedItem>());
        gtmSendEvent({
            event: "add_to_cart",
            ecommerce: {
                currency: currencyCode,
                value: grandTotal.value,
                items: getGa4Items(items, commonProps),
            },
        });
    }, [
        customPromo,
        departure?._id,
        departure?.activeExtension,
        departure?.price.value,
        departure?.status,
        departure?.tourCode,
        departure?.tourContent?.name,
        departure?.tourContent?.tour?.activityLevelContent?.name,
        departure?.tourContent?.tour?.classLevelContent?.name,
        draftQuote?.order,
        price,
    ]);
};
